module.exports = __webpack_public_path__ + "img/268Vcode.715e3421.png";